import { z } from 'zod'

export const CreateCartSchema = z.object({
    region_id: z.string().optional(),
    sales_channel_id: z.string().optional(),
    country_code: z.string().optional(),
    items: z
        .array(
            z.object({
                variant_id: z.string(),
                quantity: z.number(),
            }),
        )
        .optional(),
    context: z.record(z.unknown()).optional(),
})
